import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { usePrivacyConsent } from "../privacy/PrivacyConsentProvider";
import { trackConversion } from "./conversionTracking";

const ConversionTracker = () => {
  const location = useLocation();
  const { analyticsAllowed } = usePrivacyConsent();
  const lastTrackedPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!analyticsAllowed) {
      lastTrackedPathRef.current = null;
      return;
    }
    if (lastTrackedPathRef.current === location.pathname) return;
    lastTrackedPathRef.current = location.pathname;
    trackConversion("page_view", { pagePath: location.pathname });
  }, [analyticsAllowed, location.pathname]);

  return null;
};

export default ConversionTracker;
